import React, {Fragment} from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {CurrencyFormatter, localOptionColumn} from "../../../utils/formatters";
import DetailsButton from "../../form/DetailsButton";

class TransactionPaymentList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }
    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        if (Array.isArray(props.view)) {
            props.view.push("payment_component_id");
        } else if(!!props.view && typeof props.view !== "string") {
            props.view.payment_component_id = "";
        } else if (typeof props.view !== "string") {
            props.view = ["payment_component_id"];
        }
        return (
            <SelectorGrid
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "RealTransactionPaymentList"}
                {...props}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel"}]}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 2,
                        sortable,
                        filterable
                    },
                    "payment_component": {
                        header: 'Mozgás',
                        width: 6,
                        sortable,
                        ...(() => {
                            const config = localOptionColumn([
                                {
                                    key: "MoneyTransfer",
                                    label: "Pénzmozgás"
                                },
                                {
                                    key: "voucher",
                                    label: "Utalvány"
                                },
                                {
                                    key: "Compensation",
                                    label: "Kompenzáció"
                                },
                                {
                                    key: "invoice",
                                    label: "Számla"
                                },
                                {
                                    key: "payment",
                                    label: "Fizetés"
                                },
                                {
                                    key: "RoundingCorrection",
                                    label: "Kerekítés"
                                },
                                {
                                    key: "PaymentWriteOff",
                                    label: "Leírás"
                                },
                                {
                                    key: "SwapPayment",
                                    label: "Csere"
                                },
                            ]);
                            const r = config.renderer
                            config.renderer = (value, row) => <Fragment><DetailsButton component_type={row.payment_component} component_id={row.payment_component_id} block={false} icon={true} loader={null} def={r(value)}/> {r(value)}</Fragment>;
                            return config;
                        })(),
                    },
                    "total": {
                        header: 'Összeg',
                        width: 6,
                        sortable,
                        filterable,
                        renderer: CurrencyFormatter, className: "currency"
                    }
                }}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                selection={selection}
                onSelectionChange={(selection) => this.props.loadForm && this.props.loadForm(selection.value)}
            />
        );
    }
}

export default TransactionPaymentList;
